import { PROSPECT_GET_LIST, PROSPECT_GET_LIST_SUCCESS, PROSPECT_GET_LIST_ERROR } from '../actions';
import {
  GET_PAGING_PROSPECTIVE_HUB,
  GET_PAGING_PROSPECTIVE_HUB_ERROR,
  GET_PAGING_PROSPECTIVE_HUB_SUCCESS,
} from './types';

const initialState = {
  items: [],
  loading: false,
  itemCount: 0,
  pageCount: 0,
  error: '',
};

export default function initState(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_PAGING_PROSPECTIVE_HUB:
      return {
        ...state,
        error: null,
        loading: true,
      };
    case GET_PAGING_PROSPECTIVE_HUB_SUCCESS:
      const { itemCount, pageCount, data } = payload;
      return {
        ...state,
        loading: false,
        items: data,
        itemCount,
        pageCount,
      };

    case GET_PAGING_PROSPECTIVE_HUB_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    default:
      return { ...state };
  }
}
